import { v4 as uuidv4 } from "uuid";
import { getCookie, setCookie } from "@base/utils/cookie";

export const getAnonUserId = () => {
  const storageKey = "quiz_app_anon_user_id";

  // Try localStorage first, then fall back to cookie
  // (Safari ITP can wipe localStorage after cross-site redirects like Stripe)
  let userId = localStorage.getItem(storageKey) || getCookie(storageKey);

  if (!userId) {
    userId = uuidv4();
  }

  // Always write to both storage mechanisms to keep them in sync
  localStorage.setItem(storageKey, userId);
  setCookie(storageKey, userId);

  return userId;
};
